var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 1.99984H12.6667V0.666504H11.3334V1.99984H4.66671V0.666504H3.33337V1.99984H2.66671C1.93337 1.99984 1.33337 2.59984 1.33337 3.33317V13.9998C1.33337 14.7332 1.93337 15.3332 2.66671 15.3332H13.3334C14.0667 15.3332 14.6667 14.7332 14.6667 13.9998V3.33317C14.6667 2.59984 14.0667 1.99984 13.3334 1.99984ZM13.3334 13.9998H2.66671V6.6665H13.3334V13.9998ZM13.3334 5.33317H2.66671V3.33317H13.3334V5.33317Z",
    fill: "#A8B0B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar-today.0c2209a10cd0c665aba9b488a060068e.svg";
export { ForwardRef as ReactComponent };